<template>
  <div class="admin-layout">
    <aside class="sidebar">
      <div class="logo-section">
        <h1 class="logo">🏃 贞吉跑腿</h1>
      </div>
      <nav class="menu">
        <ul ref="menuList">
          <li 
            v-for="item in menuItems" 
            :key="item.path"
            :class="getMenuItemClass(item)"
            :ref="el => setMenuRef(el, item.path)"
          >
            <div class="menu-item-content" @click="toggleMenu(item)">
              <span class="menu-icon">{{ item.icon }}</span>
              <span class="menu-text">{{ item.name }}</span>
              <span
                v-if="item.path === '/finance' && withdrawPendingCount > 0"
                class="menu-badge"
                style="margin-left: auto; margin-right: 8px;"
              >{{ withdrawPendingCount }}</span>
              <span
                v-if="item.path === '/shop-wallet' && rechargePendingCount > 0"
                class="menu-badge"
                style="margin-left: auto; margin-right: 8px;"
              >{{ rechargePendingCount }}</span>
              <span v-if="item.children" class="menu-arrow">{{ expandedMenu === item.path ? '▼' : '▶' }}</span>
            </div>
            <ul v-if="item.children && expandedMenu === item.path" class="submenu">
              <li 
                v-for="child in item.children" 
                :key="child.path"
                :class="{ active: currentPath === child.path }"
                @click.stop="navigate(child.path)"
              >
                <span class="submenu-text">{{ child.name }}</span>
                <span
                  v-if="child.path === '/shop-wallet/recharges' && rechargePendingCount > 0"
                  class="menu-badge"
                >{{ rechargePendingCount }}</span>
                <span
                  v-else-if="child.path === '/finance/withdraw' && withdrawPendingCount > 0"
                  class="menu-badge"
                >{{ withdrawPendingCount }}</span>
              </li>
            </ul>
          </li>
        </ul>
      </nav>
    </aside>
    
    <main class="main-content">
      <header class="top-bar">
        <div class="top-left">
          <span class="page-title">{{ currentTitle }}</span>
        </div>
        <div class="top-right">
          <span class="user-info">管理员：{{ adminName }}</span>
          <button @click="logout" class="logout-btn">退出登录</button>
        </div>
      </header>
      <div class="content-wrapper">
        <router-view />
      </div>
    </main>
  </div>
</template>

<script>
import { getShopWalletRecharges } from '@/api/shop-wallet-recharge'
import { getWithdraws } from '@/api/finance'

export default {
  name: 'Layout',
  data() {
    return {
      menuItems: [
        { path: '/dashboard', name: '数据统计', icon: '📊' },
        { 
          path: '/orders', 
          name: '订单', 
          icon: '📋',
          children: [
            { path: '/orders/fee-rules', name: '订单收费计算规则' },
            { path: '/orders/list', name: '订单列表' },
            { path: '/orders/commission-roles', name: '分佣角色列表' },
            { path: '/orders/commission-allocation-rules', name: '订单服务费分配规则' }
          ]
        },
        { 
          path: '/user/user', 
          name: '用户', 
          icon: '👥', 
          children: [
            { path: '/user/users', name: '用户列表' }
          ]
        },
        {
          path: '/communities',
          name: '小区',
          icon: '🏠',
          children: [
            { path: '/communities', name: '小区列表' },
            { path: '/community-agents/list', name: '小区代理列表' },
            { path: '/community-agents/communities', name: '代理-小区关联' }
          ]
        },
        { 
          path: '/runner-referrer', 
          name: '跑手推广人', 
          icon: '🤝',
          children: [
            { path: '/runner-referrer/referrers', name: '跑手推广人列表' },
            { path: '/runner-referrer/list', name: '推广人-跑手关联' }
          ]
        },
        { 
          path: '/user/runner', 
          name: '跑手', 
          icon: '🏃', 
          children: [
            { path: '/user/runners', name: '跑手列表' },
            { path: '/user/runner-types', name: '跑手类型管理' }
          ]
        },
        { 
          path: '/shop-referrers', 
          name: '店家推广人', 
          icon: '🔗',
          children: [
            { path: '/shop-referrers/list', name: '店家推广人列表' },
            { path: '/shop-referrer-shop/list', name: '推广人-店家关联' }
          ]
        },
        { 
          path: '/user/shop', 
          name: '店家会员', 
          icon: '🏪', 
          children: [
            { path: '/user/shops', name: '店家会员列表' }
          ]
        },
        { 
          path: '/products', 
          name: '物品', 
          icon: '📦',
          children: [
            { path: '/products/categories', name: '物品分类' },
            { path: '/products/list', name: '物品列表' },
            { path: '/products/specs', name: '商品规格' },
            { path: '/products/sku', name: 'SKU 管理' }
          ]
        },
        { 
          path: '/articles', 
          name: '文章', 
          icon: '📝', 
          children: [
            { path: '/articles/categories', name: '文章分类' },
            { path: '/articles/list', name: '文章列表' }
          ]
        },
        { path: '/media', name: '素材库', icon: '📁' },
        { path: '/statistics', name: '数据报表', icon: '📈' },
        { 
          path: '/finance', 
          name: '财务管理', 
          icon: '💰',
          children: [
            { path: '/role', name: '角色总表' },
            { path: '/finance/transactions', name: '钱包流水' },
            { path: '/finance/withdraw', name: '提现审核' }
          ]
          },
          {
          path: '/shop-wallet',
          name: '店家钱包',
          icon: '🏦',
          children: [
            { path: '/shop-wallet/recharges', name: '充值审核' }
          ]
          },
          {
          path: '/admin-accounts',
          name: '管理员',
          icon: '🔐',
          children: [
            { path: '/admin-accounts/list', name: '管理员列表' },
            { path: '/admin-accounts/create', name: '新增管理员' },
            { path: '/admin-accounts/roles', name: '管理员角色' },
            { path: '/system/operation-logs', name: '操作日志' }
          ]
        },
        { path: '/system', name: '系统设置', icon: '⚙️' },
        { path: '/platform-config', name: '平台配置', icon: '🛠️' }
      ],
      currentPath: '/dashboard',
      expandedMenu: '',
      menuRefs: {},
      rechargePendingCount: 0,
      withdrawPendingCount: 0,
      rechargePollTimer: null
    }
  },
  computed: {
    currentTitle() {
      for (const item of this.menuItems) {
        if (item.path === this.currentPath) return item.name
        if (item.children) {
          const child = item.children.find(c => c.path === this.currentPath)
          if (child) return child.name
        }
      }
      return '管理后台'
    },
    adminName() {
      return localStorage.getItem('admin_username') || '未登录'
    }
  },
  watch: {
    $route(to) {
      this.currentPath = to.path
      // 路由变化时，若当前激活项属于某个含子菜单的父级，自动展开该父级
      const parent = this.menuItems.find(i => i.children && to.path.startsWith(i.path))
      if (parent) {
        this.expandedMenu = parent.path
      }
      this.$nextTick(this.scrollActiveIntoView)
    }
  },
  mounted() {
    this.currentPath = this.$route.path
    const parent = this.menuItems.find(i => i.children && this.currentPath.startsWith(i.path))
    if (parent) {
      this.expandedMenu = parent.path
    }
    this.$nextTick(this.scrollActiveIntoView)
    this.fetchPendingRecharge()
    this.fetchPendingWithdraw()
    this.rechargePollTimer = setInterval(() => {
      this.fetchPendingRecharge()
      this.fetchPendingWithdraw()
    }, 60000)
  },
  beforeDestroy() {
    if (this.rechargePollTimer) {
      clearInterval(this.rechargePollTimer)
      this.rechargePollTimer = null
    }
  },
  methods: {
    async fetchPendingRecharge() {
      try {
        const res = await getShopWalletRecharges({ status: 0, page: 1 })
        const paginator = res.data || {}
        this.rechargePendingCount = paginator.total || 0
      } catch (e) {
        // 静默失败，不影响主流程
      }
    },
    async fetchPendingWithdraw() {
      try {
        // 尚未完成打款 = 待审核(0) + 已通过(1)：这两类记录仍需财务处理/打款
        // 后端 withdraws 接口一次仅支持单个 status，故并行请求后求和
        const [pendingRes, approvedRes] = await Promise.all([
          getWithdraws({ status: 0, page: 1 }),
          getWithdraws({ status: 1, page: 1 })
        ])
        const pending = (pendingRes.data || {}).total || 0
        const approved = (approvedRes.data || {}).total || 0
        this.withdrawPendingCount = pending + approved
      } catch (e) {
        // 静默失败，不影响主流程
      }
    },
    setMenuRef(el, path) {
      if (el) {
        this.menuRefs[path] = el
      }
    },
    getMenuItemClass(item) {
      return {
        active: this.currentPath === item.path || (item.children && this.currentPath.startsWith(item.path)),
        expanded: this.expandedMenu === item.path,
        'has-children': item.children
      }
    },
    toggleMenu(item) {
      if (item.children) {
        this.expandedMenu = this.expandedMenu === item.path ? '' : item.path
        this.$nextTick(this.scrollActiveIntoView)
      } else {
        this.navigate(item.path)
      }
    },
    // 自动将当前激活项（或展开的子菜单父级）滚动到侧边栏可视区域内
    scrollActiveIntoView() {
      const menuEl = this.$refs.menuList
      if (!menuEl) return
      // 优先滚动到激活的子项所在父级，其次滚动到激活的父级
      const activeParent = this.menuItems.find(
        i => i.children && this.currentPath.startsWith(i.path)
      )
      const targetPath = activeParent ? activeParent.path : this.currentPath
      const targetEl = this.menuRefs[targetPath]
      if (!targetEl) return
      const menuRect = menuEl.getBoundingClientRect()
      const targetRect = targetEl.getBoundingClientRect()
      // 仅当目标不在可视区域内时才滚动
      if (targetRect.top < menuRect.top || targetRect.bottom > menuRect.bottom) {
        targetEl.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
      }
    },
    navigate(path) {
      if (this.$route.path === path) return
      this.$router.push(path)
    },
    logout() {
      localStorage.removeItem('admin_token')
      localStorage.removeItem('admin_username')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  min-height: 100vh;
}

.sidebar {
  width: 220px;
  background: linear-gradient(180deg, #1a1a2e 0%, #16213e 100%);
  color: #fff;
  display: flex;
  flex-direction: column;
  position: fixed;
  height: 100vh;
  left: 0;
  top: 0;
}

.logo-section {
  padding: 20px;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}

.logo {
  font-size: 18px;
  font-weight: 600;
  margin: 0;
}

.menu {
  flex: 1;
  padding: 15px 0;
  overflow-y: auto;
  overflow-x: hidden;
}

.menu::-webkit-scrollbar {
  width: 6px;
}

.menu::-webkit-scrollbar-thumb {
  background: rgba(255,255,255,0.2);
  border-radius: 3px;
}

.menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255,255,255,0.35);
}

.menu::-webkit-scrollbar-track {
  background: transparent;
}

.menu ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu li {
  padding: 0;
}

.menu-item-content {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  cursor: pointer;
  transition: background 0.3s;
}

.menu-item-content:hover {
  background: rgba(255,255,255,0.1);
}

.menu li.active > .menu-item-content {
  background: #667eea;
}

.menu-icon {
  font-size: 18px;
  margin-right: 10px;
}

.menu-text {
  font-size: 14px;
}

.menu-arrow {
  margin-left: auto;
  font-size: 10px;
  color: rgba(255,255,255,0.5);
}

.submenu {
  list-style: none;
  padding: 0;
  margin: 4px 0;
  background: rgba(26, 26, 46, 0.95);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.3);
  white-space: nowrap;
}

.submenu li {
  padding: 10px 20px 10px 50px;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  cursor: pointer;
  transition: background 0.3s;
}

.submenu li:hover {
  background: rgba(255,255,255,0.1);
}

.submenu li.active {
  background: #667eea;
}

.submenu-text {
  color: rgba(255,255,255,0.85);
  white-space: nowrap;
}

.menu-badge {
  margin-left: auto;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  background: #e74c3c;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  border-radius: 9px;
}

.main-content {
  flex: 1;
  margin-left: 220px;
  display: flex;
  flex-direction: column;
}

.top-bar {
  background: #fff;
  padding: 15px 25px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}

.page-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.top-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.user-info {
  color: #666;
  font-size: 14px;
}

.logout-btn {
  padding: 8px 16px;
  background: #e74c3c;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.content-wrapper {
  flex: 1;
  padding: 20px;
  background: #f5f7fa;
}
</style>